import { render, staticRenderFns } from "./DialogTips.vue?vue&type=template&id=f9696b28&scoped=true&"
import script from "./DialogTips.vue?vue&type=script&lang=js&"
export * from "./DialogTips.vue?vue&type=script&lang=js&"
import style0 from "./DialogTips.vue?vue&type=style&index=0&id=f9696b28&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9696b28",
  null
  
)

export default component.exports